// Importando os tipos das suas stores.
// É assumido que cada um desses arquivos agora exporta uma classe TypeScript.

import OrganizationStore from "stores/OrganizationStore";
import UserStore from "stores/UserStore";
import CompanyStore from "stores/CompanyStore";
import LockerStore from "stores/LockerStore";
import DoorsStore from "./DoorsStore";
import FlowStore from "./FlowStore";
import AllocationStore from "./AllocationStore";

/**
 * Interface que define a estrutura do objeto que agrupa todas as stores.
 * Facilita a tipagem e o autocompletar em outras partes do código.
 */
export interface IStores {
  lockerStore: LockerStore;
  doorsStore: DoorsStore;
  companyStore: CompanyStore;
  organizationStore: OrganizationStore;
  flowStore: FlowStore;
  userStore: UserStore;
  allocationStore: AllocationStore;
  localStorage: Storage;
}

/**
 * A classe RootStore é o contêiner central para todas as stores do MobX.
 * Ela é responsável por instanciar e fornecer acesso às outras stores.
 */
class RootStore {
  // Declaração das propriedades com seus respectivos tipos
  lockerStore: LockerStore;
  doorsStore: DoorsStore;
  companyStore: CompanyStore;
  organizationStore: OrganizationStore;
  flowStore: FlowStore;
  userStore: UserStore;
  allocationStore: AllocationStore;
  localStorage: Storage;

  // Propriedade privada para cachear o objeto de stores
  private _mobxStores: IStores | null = null;

  constructor() {
    // Instancia cada store no construtor
    this.lockerStore = new LockerStore();
    this.doorsStore = new DoorsStore();
    this.companyStore = new CompanyStore();
    this.organizationStore = new OrganizationStore();
    this.flowStore = new FlowStore();
    this.userStore = new UserStore();
    this.allocationStore = new AllocationStore();

    // Atribui a API global de localStorage do navegador
    this.localStorage = localStorage;
  }

  /**
   * Getter que retorna um objeto com todas as stores.
   * Utiliza um cache para evitar a recriação do objeto a cada chamada.
   */
  get mobxStores(): IStores {
    if (!this._mobxStores) {
      this._mobxStores = {
        lockerStore: this.lockerStore,
        doorsStore: this.doorsStore,
        companyStore: this.companyStore,
        organizationStore: this.organizationStore,
        flowStore: this.flowStore,
        userStore: this.userStore,
        allocationStore: this.allocationStore,
        localStorage: this.localStorage,
      };
    }
    return this._mobxStores;
  }
}

// --- Padrão Singleton ---
// Variável para armazenar a instância única da RootStore
let store: RootStore | null = null;

/**
 * Função "fábrica" que inicializa a RootStore (se ainda não foi)
 * e a retorna. Garante que exista apenas uma instância da RootStore
 * em toda a aplicação.
 */
export function initializeStores(): RootStore {
  if (store === null) {
    store = new RootStore();
  }
  return store;
}

export default RootStore;